// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"5219e61c","453":"7e063b81"}[chunkId] + ".chunk.js";
};